import React from 'react';
import { Redirect} from 'react-router-dom';
import {ERROR_PAGE_NOT_FOUND} from './redux/constants'

export default function PageNotFound() {
  return <Redirect to="/" />; //COT-9353: SIA+ Screen refresh issue. if incorrect path will redirect to dashboard
}
